import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { metrics } from '../../data/content';

const MetricsSection = () => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 py-16 border-y border-slate-200 dark:border-slate-800 mt-0">
      {metrics.map((metric, index) => (
        <motion.div 
          key={index} 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.1 }}
          className="text-center md:text-left"
        >
          <div className="flex items-center justify-center md:justify-start gap-3 mb-2 text-brand-red dark:text-brand-yellow">
            <SafeIcon name={metric.icon.replace('Fi', '')} className="w-5 h-5" />
            <span className="text-[10px] uppercase tracking-widest font-bold text-slate-500 dark:text-slate-400">{metric.label}</span>
          </div>
          <p className="text-4xl md:text-5xl font-heading font-black text-brand-dark dark:text-white transition-colors duration-300">
            {metric.value}
          </p>
        </motion.div>
      ))}
    </div>
  );
};

export default MetricsSection;